import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';

export const SHELTER_RELATED_LINK_GET_BREEDS = graphql(`
  query ShelterRelatedLinksGetBreeds(
    $take: Int
    $where: DogBreedWhereInput
    $translationsWhere: DogBreedTranslationWhereInput
  ) {
    findManyDogBreed(where: $where, take: $take) {
      id
      translations(where: $translationsWhere) {
        id
        url
        name
      }
    }
  }
`);

export const useGetBreeds = () => {
  const { language } = useRouter();

  const { data, error, loading } = useQuery(SHELTER_RELATED_LINK_GET_BREEDS, {
    variables: {
      translationsWhere: { language: { equals: language } },
      where: {
        AND: [
          {
            translations: {
              every: {
                AND: [
                  { description: { not: { equals: '' } } },
                  { description: { not: { equals: null } } },
                ],
              },
            },
          },
          { isSubBreed: { equals: false } },
        ],
      },
    },
    ssr: false,
  });

  return {
    // We want them random
    breeds: data?.findManyDogBreed ? data.findManyDogBreed.slice(0, 10) : [],
    breedsError: error,
    breedsLoading: loading,
  };
};
